import Page from "components/Page";
import { Props } from "./Surveys";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const Surveys = lazyWithRetry(() => import("./Surveys"));

export default (props: Props) => (
  <Page>
    <Surveys {...props} />
  </Page>
);
